export default __webpack_public_path__ + "static/media/undraw_travel.d38da53e.svg";